var brief;

brief = function() {
  var $, getManager, module, moduleName;
  $ = require('jquery');
  require('malihu-custom-scrollbar-plugin')($);
  moduleName = 'brief';
  module = $("." + moduleName);
  getManager = function() {
    var get, manager, showManager, url;
    url = location.href;
    if (url.includes('?m=')) {
      get = location.search.substr(1);
      showManager = function(managerName) {
        var container, inp, node;
        container = module.find("." + moduleName + "__js-manager");
        inp = module.find("[name='namemanager']");
        node = container.find('.name');
        container.show();
        node.html(managerName);
        inp.val(managerName);
        return inp.focus();
      };
      switch (get) {
        case 'm=ximich':
          manager = 'Артем Химич';
          return showManager(manager);
        case 'm=vk':
          manager = 'Вадим Коренев';
          return showManager(manager);
        case 'm=di':
          manager = 'Дарья Исподкина';
          return showManager(manager);
        case 'm=dem':
          manager = 'Владислав Дементьев';
          return showManager(manager);
        case 'm=borod':
          manager = 'Илья Бородин';
          return showManager(manager);
        case 'm=voytuk':
          manager = 'Никита Войтюк';
          return showManager(manager);
        case 'm=boykov':
          manager = 'Никита Бойков';
          return showManager(manager);
        case 'm=smirnov':
          manager = 'Никита Смирнов';
          return showManager(manager);
        case 'm=mav':
          manager = 'Анатолий Воронин';
          return showManager(manager);
        case 'm=mad':
          manager = 'Наталия Данилова';
          return showManager(manager);
        case 'm=mgk':
          manager = 'Георгий Кузнецов';
          return showManager(manager);
        case 'm=mmc':
          manager = 'Михаил Смилянец';
          return showManager(manager);
        case 'm=mat':
          manager = 'Андрей Терентьев';
          return showManager(manager);
        case 'm=mns':
          manager = 'Николай Шепилов';
          return showManager(manager);
        case 'm=mrf':
          manager = 'Рустам Фазлеев';
          return showManager(manager);
        case 'm=mar':
          manager = 'Александр Рыбалко';
          return showManager(manager);
      }
    }
  };
  if (module.length > 0) {
    return getManager();
  }
};

module.exports = brief;
